<template>
    <footer class="footer has-background-dark" style="padding: 3rem 1.5rem 2rem;">
  <div class="content has-text-centered ">
    <p>
      <!-- <strong class="has-text-white">Portfolio</strong> by <a href="https://google.com">Davey Hurkmans</a>  -->
      <a class="has-text-white" href="https://github.com/DaveyHurkmans"><font-awesome-icon :icon="['fab', 'github']" /></a> 
      <a class="has-text-white" href="https://www.linkedin.com/in/daveyhurkmans/"><font-awesome-icon :icon="['fab', 'linkedin']" /></a> 
      <a class="has-text-white" href="mailto:daveyhurkmansdh@gmail.com"><font-awesome-icon icon="fa-solid fa-envelope" /></a> 
    </p>
  </div>
</footer>
</template>

<script>
export default {
  name: 'BasicFooter',
  props: {
    msg: String
    }
  }
</script>

<style>

a {
  margin: 1rem;
}

.svg-inline--fa {
  height: 2em;
}

</style>

library.add(faGithub)
library.add(faLinkedin)
library.add(faEnvelope)
library.add(faUserSecret)